import { Component, css, html, LitElement, property } from '@rxdi/lit-html';

import { facebook, github, google, terra, twitter } from './icons';

type Providers = 'github' | 'facebook' | 'twitter' | 'google' | 'terra';

const ICONS = { facebook, github, twitter, google, terra };

/** <social-login-button type="google">Continue with Google</social-login-button> - studio pill button. */
@Component({
  selector: 'social-login-button',
  styles: [
    css`
      :host {
        display: block;
        width: 100%;
      }

      button {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 12px;
        width: 100%;
        height: 54px;
        padding: 0 22px;
        border-radius: 999px;
        border: 1px solid var(--rs-line-strong);
        background: var(--rs-surface-2);
        color: var(--rs-text);
        font: 600 15px var(--rs-font-body);
        cursor: pointer;
        transition: transform 0.25s var(--rs-ease), border-color 0.25s var(--rs-ease), box-shadow 0.25s var(--rs-ease);
      }

      button:hover,
      :host([active]) button {
        transform: translateY(-2px);
        border-color: var(--rs-signal);
        box-shadow: var(--rs-shadow-signal);
      }

      button:focus-visible {
        outline: 2px solid var(--rs-signal);
        outline-offset: 3px;
      }

      .icon {
        display: grid;
        place-items: center;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        background: var(--rs-text);
        color: var(--rs-ink);
      }

      .icon svg {
        width: 16px;
        height: 16px;
      }
    `,
  ],
  template(this: SocialLoginButtonComponent) {
    return html`
      <button type="button">
        <span class="icon">${(ICONS[this.type] ?? ICONS.github)('currentColor')}</span>
        <slot></slot>
      </button>
    `;
  },
})
export class SocialLoginButtonComponent extends LitElement {
  @property() type: Providers = 'github';
  @property({ type: Boolean, reflect: true }) active: boolean;
}
